import styled from "styled-components/macro";

export const Section = styled.div(({ theme }) => ({
  background: theme.color.neutral["08"],
  boxShadow: theme.shadow.level["01"],
  flexGrow: 1,
}));
